import React from 'react';
import PropTypes from 'prop-types';
import GenericError from './GenericError';
import NavigationHistory from '../../libs/NavigationHistory';

/**
 * Show the server state errors on an event detail.
 */

const TimesheetsError = (props) => {
  const { errorCode, navigationHistory } = props;
  return (
    <GenericError
      message401={i18n('You are not allowed to view your timesheets.')}
      message403={i18n('You are not allowed to view your timesheets.')}
      message404={i18n('Your timesheets could not be found.')}
      navigationHistory={navigationHistory}
      errorCode={errorCode}
    />
  );
};

TimesheetsError.propTypes = {
  errorCode: PropTypes.oneOf(['', 400, 401, 403, 404, 429, 502, 503]),
  navigationHistory: PropTypes.instanceOf(NavigationHistory).isRequired
};

export default TimesheetsError;
